<template>
  <!-- Main Start -->
  <div class="main">
    <section class="page-body p-0">
      <div class="row">
        <div class="order-2 order-lg-1 col-lg-5">
          <div class="content-box">
            <div>
              <h5>¿Has Olvidado tu contraseña? </h5>
              <p class="font-md content-color">
                Digita tu correo electrónico que tengas registrado en la tienda; te llegará un código.
              </p>

              <form action="#" class="custom-form form-pill" @submit.prevent="forgotPassword">
                <div class="input-box1">
                  <label for="email">Email</label>
                  <input
                    id="email"
                    name="email"
                    class="form-control"
                    type="email"
                    v-model.trim="email"
                    @input="sanitizeEmail"
                    @keypress="blockBadChars"
                    @keyup.enter="forgotPassword"
                    autocomplete="email"
                    inputmode="email"
                    maxlength="254"
                    required
                  />
                </div>

                <button
                  type="button"
                  @click="forgotPassword"
                  v-if="!loading"
                  class="btn-solid rounded-pill line-none"
                >
                  Enviar Código <i class="arrow"></i>
                </button>
                <div class="loader-5 center" v-else><span></span></div>
              </form>

              <router-link to="/login" class="backto-link font-default theme-color">
                Iniciar Sesión
              </router-link>
            </div>
          </div>
        </div>

        <div class="order-1 order-lg-2 col-lg-7">
          <div class="img-box">
            <img class="bg-img" src="/assets/images/bg/bg-zd-000.jpg" alt="banner" />
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- Main End -->
</template>

<script>
import myApi from '../../../plugins/axios'

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: null,
      loading: false,
      cookie: null,
    }
  },
  methods: {
    // Quita cualquier carácter que no sea permitido (whitelist)
    sanitizeEmail(e) {
      const original = e.target.value || ''
      // Solo permite letras, números y estos símbolos: @ . _ + -
      const cleaned = original.replace(/[^A-Za-z0-9@._+-]/g, '')
      // Evita dobles puntos o puntos junto a @ (opcional, mejora la higiene)
      const cleaned2 = cleaned.replace(/\.{2,}/g, '.')
      if (cleaned2 !== original) {
        e.target.value = cleaned2
        this.email = cleaned2
      } else {
        this.email = original
      }
    },

    // Bloquea desde el teclado caracteres peligrosos/raros (incluye comillas y espacios)
    blockBadChars(ev) {
      const ch = ev.key
      // Espacio o cualquiera de estos: ' " \ < > ; ( ) { }
      if (/\s|['"\\<>;(){}]/.test(ch)) {
        ev.preventDefault()
      }
    },

    // Valida estructura de email + longitudes (bastante estricta y práctica)
    isValidEmail(email) {
      if (!email || typeof email !== 'string') return false

      // Normaliza y recorta
      const normalized = email.normalize('NFKC').trim()

      // Rechaza si tiene caracteres prohibidos
      if (/['"\\<>;(){}]/.test(normalized)) return false

      // Longitud total máxima típica
      if (normalized.length > 254) return false

      // Debe tener una sola @
      const parts = normalized.split('@')
      if (parts.length !== 2) return false

      const [local, domain] = parts
      if (!local || !domain) return false

      // Longitud por parte (prácticas comunes)
      if (local.length > 64) return false

      // Regex práctico (acepta letras, números y . _ % + - en local; dominio con subdominios y TLD de 2+)
      const re =
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

      if (!re.test(normalized)) return false

      // Cada etiqueta del dominio máximo 63
      const labels = domain.split('.')
      if (labels.some(l => l.length === 0 || l.length > 63)) return false

      return true
    },

    async forgotPassword() {
      try {
        if (!this.email) {
          this.$notify({
            title: 'Ingresa una dirección de correo electrónico.',
            duration: 3500,
            type: 'error',
          })
          return
        }

        // Validación estricta
        if (!this.isValidEmail(this.email)) {
          this.$notify({
            title: 'Correo inválido',
            text: 'Usa un correo válido (solo letras, números y @ . _ + -).',
            duration: 3500,
            type: 'error',
          })
          return
        }

        this.loading = true

        // Opcional: enviar la versión normalizada/minúscula
        const payload = { email: this.email.trim().toLowerCase() }

        const resp = await myApi.post('ecommerce/forgot_password/', payload)

        this.loading = false

        if (resp.data.message == 403) {
          this.$notify({
            title: 'VALIDACIÓN',
            text: `${resp.data.message_text}`,
            duration: 3500,
            type: 'error',
          })
        } else {
          this.$notify({
            title: 'CONTRASEÑA',
            text: 'Se envió un código de acceso a tu correo para recuperar tu contraseña.',
            duration: 3500,
          })
          this.$cookies.set('forgot_password', { email: payload.email }, '30MIN')
          setTimeout(() => {
            this.$router.push({ name: 'CodeOtp' })
          }, 50)
        }
        console.log(resp)
      } catch (error) {
        this.loading = false
        this.$notify({
          title: 'INTERNO',
          text: 'Surgió un problema en el servidor. Comunícate con el soporte de la página.',
          duration: 3500,
          type: 'error',
        })
        console.log(error)
      }
    },
  },
  created() {
    this.cookie = this.$cookies.get('forgot_password') ? this.$cookies.get('forgot_password') : null
    if (this.cookie) {
      this.$router.push({ name: 'CodeOtp' })
    }
    console.log(this.cookie)
  },
}
</script>
